import AxiosClient from '../AxiosClient';
import { SERVICE, ENV } from "../../Config/constants";

const service = AxiosClient.getInstance();

//Validate Email Address
export const validateEmailAddress = async (activationKey, persona, email) => {
  const url = `${ENV}${SERVICE.USER.VALIDATE_EMAIL}?actKey=${activationKey}&persona=${persona}&reqEmail=${encodeURIComponent(email)}`;
  return service.GetApiRequest(url);
};

//Add Admin
export const addUserApi = async (req) => {
  const URL = `${ENV}${SERVICE.USER.REGISTER_USER}`;
  return service.PostApiRequest(URL, req);
}

export const updateUserApi = async (req) => {
  const URL = `${ENV}${SERVICE.USER.UPDATE_USER}`;
  return service.PutApiRequest(URL, req);
}

//Get User Details
export const getUserDetailsApi = async (email, activationKey) => {
  const url = `${ENV}${SERVICE.PROFILE.GET_PROFILE_DETAILS}?reqEmail=${encodeURIComponent(email)}`;
  return service.GetApiRequest(url, { ['activationKey']: activationKey });
};

//Get Language Details
export const getLanguageDetailsApi = async () => {
  const url = `${ENV}${SERVICE.PROFILE.GET_LANGUAGE_DETAILS}`;
  return service.GetApiRequest(url);
}

export const getEmailRegexApi = async () => {
  const url = `${ENV}${SERVICE.PROFILE.EMAIL_REGEX}`;
  return service.GetApiRequest(url);
}